export class ProgramRuleTypes {
    public static readonly MUTUALLY_EXCLUSIVE = { name: 'Mutually Exclusive', value: 'ME' };
    public static readonly EXCLUSIVE_PER_LOCATION = { name: 'Exclusive Per Location', value: 'EPL' };
}